export default "__VITE_PUBLIC_ASSET__1b239e0c__"